function billing(state = {}, action) {
	switch (action.type) {
		case 'GET_CALC_PLAN_SUCCESS':
			return {
				...state,
				menu: action.payload && action.payload.data && action.payload.data.payment_definitions
			};
		case 'CREATE_PLAN_SUCCESS':
			return {
				...state,
				plan: action.payload && action.payload.data
			};
		case 'GET_TERMINATE_PLAN_SUCCESS':
			return {
				...state,
				terminatedPlan: action.payload && action.payload.data
			};
		default:
			return state;
	}
}

export default billing;



// WEBPACK FOOTER //
// ./routes/app/routes/checkout/reducer/index.js